import React, { useEffect, useState } from 'react';
import { Search, Filter, ArrowUpDown, ArrowUp, ArrowDown, ChevronLeft, ChevronRight, X, ChevronDown, ChevronUp } from 'lucide-react';
import { Outlet, useOutletContext, useSearchParams } from 'react-router-dom';
import { AutoCompleteDropdown } from './autoCompleteDropdown';
import { CustomDatePicker } from './datePicker';
import { useDebouncedState } from '@mantine/hooks';
import { useGlobalSearch, useInvoiceslistPagewise } from './hooks';
import LoaderFull from '../shared/loader-full-screen';



function GlobalInvoiceList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchTerm, setSearchTerm] = useState(searchParams.get('keyword') || '');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showFilters, setShowFilters] = useState(false);
  const {getpageSizeCall, setpageSizeCall} = useOutletContext();
  

  // Filter states
  const [selectedClient, setSelectedClient] = useState('');
  const [selectedVendor, setSelectedVendor] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedProjectType, setSelectedProjectType] = useState('');
  const [DebounceSearch, setDebounceSearch] = useDebouncedState(searchTerm, 500);

  // Sort states
  const [sortField, setSortField] = useState(null);
  const [sortDirection, setSortDirection] = useState(null);
  const [Filters, setFilters] = useState({});

  const clearAllFilters = () => {
    setFilters({});
    setShowFilters(false);
    setSearchTerm('');
    setDebounceSearch('');
    setSelectedClient('');
    setSelectedVendor('');
    setSelectedCategory('');
    setSelectedProjectType('');
    setSortField(null);
    setSortDirection(null);
    setCurrentPage(1);
  };

  const hasActiveFilters = Object.keys(Filters).length !== 0 || searchTerm || selectedClient || selectedVendor || selectedCategory || selectedProjectType || sortField;

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(prev => prev === 'asc' ? 'desc' : prev === 'desc' ? null : 'asc');
      if (sortDirection === 'desc') {
        setSortField(null);
      }
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const getSortIcon = (field) => {
    if (sortField !== field) return <ArrowUpDown className="w-4 h-4" />;
    if (sortDirection === 'asc') return <ArrowUp className="w-4 h-4" />;
    if (sortDirection === 'desc') return <ArrowDown className="w-4 h-4" />;
    return <ArrowUpDown className="w-4 h-4" />;
  };

  const [listData, setlistData] = useState([])


  // const inv_list_hook = useInvoiceslistPagewise()
  const global_search_hook = useGlobalSearch()


  // const handleKeyDown = (event) => {
  //   if (event.key === 'Enter') {
  //     let bd = {
  //       keyword: searchParams.get('keyword') , 
  //       client: true,
  //       client_limit: 20,
  //       client_page: 1,
        
  //       vendor: true,
  //       vendor_limit: 20,
  //       vendor_page: 1,
  //       category: true,
  //       category_limit: 20,
  //       category_page: 1,

  //       invoice: true,
  //       invoice_limit: 20,
  //       invoice_page: 1,

  //       contract: true,
  //       contract_limit: 20,
  //       contract_page: 1,
  //     }
  //     global_search_hook.mutate(bd)
  //     // trigger search logic here
  //   }
  // };

  useEffect(() => {
    if (searchParams.get('keyword')?.trim() === '' || searchParams.get('keyword') === null) { 
      setSearchTerm('')
			setlistData([]);
			return;
		}
    setlistData([]);
    let bd = {
        keyword: searchParams.get('keyword')?.trim() , 
        client: true,
        client_limit: 20,
        client_page: 1,
        
        vendor: true,
        vendor_limit: 20,
        vendor_page: 1,
        category: true,
        category_limit: 20,
        category_page: 1,

        invoice: true,
        invoice_limit: 20,
        invoice_page: 1,

        contract: true,
        contract_limit: 20,
        contract_page: 1,
      }
      global_search_hook.mutate(bd)
  }, [searchParams.get('keyword')])
  

  useEffect(() => {
    if (global_search_hook.isSuccess && global_search_hook.data) {
      setlistData(global_search_hook.data);
    }
  }, [global_search_hook.isSuccess, global_search_hook.data])

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      keyword: DebounceSearch
    }));
  }, [DebounceSearch])
  






  return (
    <div className="min-h-screen bg-gray-50 w-full">
      {/* Header */}
      <div className="vLBG p-6">
        <div className="flex w-full gap-4 items-center">
          <h1 class="text-lg font-normal text-primary"><strong class="font-black">Global Search</strong></h1>
          {/* Search Bar */}
          <div className="grow relative">
            <Search className="absolute top-4 ml-3 text-gray-400 w-5 h-5" />
            <input
              type="text"
              placeholder="Type a text here..."
              value={searchTerm}
              // onKeyDown={handleKeyDown}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setDebounceSearch(e.target.value);
                // setCurrentPage(1);
              }}
              className="w-full px-10 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
            />

            {hasActiveFilters && (
              <button
                onClick={clearAllFilters}
                className="bg-transparent border border-gray-900 outline-none absolute top-3 right-3 size-6 rounded-full flex items-center justify-center"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>
      </div>


      {/* Collapsible Filters */}
      {/* {showFilters && (
        <div className='p-6'>
          <div className="flex flex-wrap gap-4">
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "fname", name: "fname", lable: "Invoice Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "client_id", name: "client", lable: "Client Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "vendor_id", name: "vendor", lable: "Vendor Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "category_id", name: "category_name", lable: "Category Name" }} />
            <AutoCompleteDropdown setFilters={setFilters} Filters={Filters} col={{ id: "project_type_id", name: "project_type", lable: "Project Type" }} />
            <div className='flex lg:w-[49%] items-center mb-2'>
                <CustomDatePicker setFilters={setFilters} Filters={Filters} col={{ name: "published_on", lable: "Published On" }} />
            </div>
          </div>
        </div>
      )} */}


      {/* Main Content */}
      <div className="w-full p-6 border-t">
        {/* Sort Controls */}
        {/* <div className="flex flex-wrap gap-4 mb-6">
          <div className="flex items-center space-x-2 text-sm text-gray-600">
            <span>Sort by:</span>
            <button
              onClick={() => handleSort('publishedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'publishedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Published</span>
              {getSortIcon('publishedOn')}
            </button>
            <button
              onClick={() => handleSort('uploadedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'uploadedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Uploaded</span>
              {getSortIcon('uploadedOn')}
            </button>
            <button
              onClick={() => handleSort('updatedOn')}
              className={`flex items-center space-x-1 px-3 py-1 rounded-md transition-colors ${sortField === 'updatedOn' ? 'bg-blue-100 text-blue-800' : 'hover:bg-gray-100'
                }`}
            >
              <span>Updated</span>
              {getSortIcon('updatedOn')}
            </button>
          </div>
        </div> */}

        {/* Results Count */}
        {/* <div className="mb-6 text-sm text-gray-600">
          Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, sortedData.length)} of {sortedData.length} results
        </div> */}

        {/* List View */}

        {global_search_hook.isPending ? <LoaderFull /> : <Outlet context={{
          paginatedData: listData,
          getpageSizeCall: getpageSizeCall,
          setpageSizeCall: setpageSizeCall
        }} />
        }

      </div>
    </div>
  );
}

export default GlobalInvoiceList;